import { useEffect, useRef, useState } from "react";
import { fetchCoachTeamStyle } from "../coachServices";
import { teamKey } from "../coachUtils";

const UNAVAILABLE = { available: false, reason: "feed_error" };

// The Performance tab's team style (coach/team/style/), fetched once per
// team and season the first time `enabled` holds, and kept for the visit.
// Each answer is stored under its own key, so a late reply for a previous
// team never shows on the current one. While enabled without a `team` yet
// (the roster for it is still loading) it reads as loading and asks nothing.
const useTeamStyle = ({ team, season, enabled }) => {
  const key = `${teamKey(team)}|${season || ""}`;
  const [styles, setStyles] = useState({});
  const requested = useRef(new Set());

  useEffect(() => {
    if (!enabled || !team || requested.current.has(key)) return;
    requested.current.add(key);
    fetchCoachTeamStyle(team, season)
      .catch(() => UNAVAILABLE)
      .then((style) => setStyles((prev) => ({ ...prev, [key]: style || UNAVAILABLE })));
    // `key` stands for team and season.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, key]);

  return { style: styles[key] || null, loading: enabled && !(key in styles) };
};

export default useTeamStyle;
